// Export a factory that builds the options object used by Highcharts.stockChart.
// We accept the Highcharts instance and the prepared chartData so that
// formatters that reference Highcharts still work without importing it here.
export default function createHighchartsOptions(Highcharts, chartData) {
  return {
    chart: {
      height: "13%",
      marginRight: 20,
      zoomType: "x",
      panning: {
        enabled: true,
      },
      panKey: "shift",
      resetZoomButton: {
        // styles of reset zoom button
        position: {
          x: -50,
          y: -32,
        },
        theme: {
          padding: 4,
          r: 4,
        },
      },
      events: {
        exportData: function (e) {
          const headerRow = e.dataRows[0];
          headerRow.push("Reason");

          const points = this.series[0].points;

          for (let i = 1; i < e.dataRows.length; i++) {
            const point = points[i - 1];
            const reason = point?.rsn || point?.options?.rsn || "";
            e.dataRows[i].push(reason);
          }
        },
      },
    },
    title: {
      text: '<span style="color:white">.</span>',
      align: "left",
      style: { color: "#333", fontWeight: "bold", fontSize: "16px" },
    },

    credits: {
      enabled: false,
    },

    rangeSelector: {
      enabled: false,
    },
    navigator: { enabled: false },

    scrollbar: {
      enabled: false,
    },

    xAxis: {
      type: "datetime",
      ordinal: false,
      labels: {},
    },

    yAxis: {
      title: {
        text: null,
      },
      opposite: false,
      tickPositions: [0, 1],
      min: 0,
      max: 1,
    },

    tooltip: {
      useHTML: true,
      xDateFormat: "%d/%m/%Y, %H:%M:%S",
      formatter: function () {
        return `<b>${Highcharts.dateFormat("%e %b %Y %H:%M:%S", this.x)}</b><br/>State: <span style="color:${this.y === 1 ? "green" : "black"}; font-weight: 700;">${this.y} (${this.y === 1 ? "ON" : "OFF"})</span><br/>Reason: ${this.rsn || "N/A"}`;
      },
      split: false,
      shared: false,
      followPointer: false,
      outside: true,
      positioner: function (labelWidth, labelHeight, point) {
        const chart = this.chart;
        let x, y;
        x = chart.plotLeft + point.plotX - labelWidth / 2;
        y = -20;
        if (x < chart.plotLeft) {
          x = chart.plotLeft;
        }
        if (x + labelWidth > chart.plotLeft + chart.plotWidth) {
          x = chart.plotLeft + chart.plotWidth - labelWidth;
        }
        return { x: x, y: y };
      },
    },

    series: [
      {
        name: "Steps",
        type: "area",
        step: "left",
        data: chartData,
        color: "#8884d8",
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "rgba(136, 132, 216, 0.8)"],
            [1, "rgba(136, 132, 216, 0.3)"],
          ],
        },
        lineWidth: 1,
        marker: {
          enabled: false,
        },
        dataGrouping: {
          enabled: false,
        },
      },
    ],

    plotOptions: {
      series: {
        turboThreshold: 0,
        states: {
          hover: {
            lineWidthPlus: 0,
          },
        },
      },
    },
    exporting: {
      enabled: true,
      allowHTML: true,
      buttons: {
        contextButton: {
          enabled: true,
          menuItems: [
            "viewFullscreen",
            "printChart",
            "separator",
            "downloadCSV",
            "downloadXLS",
            "downloadPNG",
            "downloadJPEG",
            "downloadPDF",
            "downloadSVG",
          ],
        },
      },
    },
  };
}
